import { Injectable } from '@angular/core';
import {
	Router,
	Resolve,
	RouterStateSnapshot,
	ActivatedRouteSnapshot
} from '@angular/router';

import { User } from '@core/models/user';
import { UserService } from '@core/services/user.service';

@Injectable()
export class UserResolver implements Resolve<User> {

	constructor(private userService: UserService,
		private router: Router) {

	}

	async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<User> {

		const user = await this.userService.initializeUser();
		return user;
	}
}